// uuid4 function taken from stackoverflow
// https://stackoverflow.com/a/2117523/554903

export var uuidv4 = function uuidv4() {
  var crypto = window.crypto || window.msCrypto;
  return ([1e7] + -1e3 + -4e3 + -8e3 + -1e11).replace(/[018]/g, function (c) {
    return (c ^ crypto.getRandomValues(new Uint8Array(1))[0] & 15 >> c / 4).toString(16);
  });
};
export var serializeForm = function serializeForm(form) {
  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  if (!form) return '';
  var w = options.w || window;
  var element = options.element;
  var formData = new w.FormData(form);
  var data = Array.from(formData, function (e) {
    return e.map(encodeURIComponent).join('=');
  });
  var submitButton = form.querySelector('input[type=submit]');
  if (element && element.name && element.nodeName === 'INPUT' && element.type === 'submit') {
    data.push("".concat(encodeURIComponent(element.name), "=").concat(encodeURIComponent(element.value)));
  } else if (submitButton && submitButton.name) {
    data.push("".concat(encodeURIComponent(submitButton.name), "=").concat(encodeURIComponent(submitButton.value)));
  }
  return Array.from(new Set(data)).join('&');
};
export var camelize = function camelize(value) {
  var uppercaseFirstLetter = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
  if (typeof value !== 'string') return '';
  value = value.replace(/[\s_](.)/g, function ($1) {
    return $1.toUpperCase();
  }).replace(/[\s_]/g, '').replace(/^(.)/, function ($1) {
    return $1.toLowerCase();
  });
  if (uppercaseFirstLetter) value = value.substr(0, 1).toUpperCase() + value.substr(1);
  return value;
};
export var debounce = function debounce(callback) {
  var delay = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 250;
  var timeoutId;
  return function () {
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    clearTimeout(timeoutId);
    timeoutId = setTimeout(function () {
      timeoutId = null;
      callback.apply(void 0, args);
    }, delay);
  };
};
export var extractReflexName = function extractReflexName(reflexString) {
  var match = reflexString.match(/(?:.*->)?(.*?)(?:Reflex)?#/);
  return match ? match[1] : '';
};
export var emitEvent = function emitEvent(event, detail) {
  document.dispatchEvent(new CustomEvent(event, {
    bubbles: true,
    cancelable: false,
    detail: detail
  }));
  if (window.jQuery) window.jQuery(document).trigger(event, detail);
};

// construct a valid xPath for an element in the DOM
export var elementToXPath = function elementToXPath(element) {
  if (element.id !== '') return "//*[@id='" + element.id + "']";
  if (element === document.body) return '/html/body';
  var ix = 0;
  var siblings = element.parentNode.childNodes;
  for (var i = 0; i < siblings.length; i++) {
    var sibling = siblings[i];
    if (sibling === element) {
      var computedPath = elementToXPath(element.parentNode);
      var tagName = element.tagName.toLowerCase();
      var ixInc = ix + 1;
      return "".concat(computedPath, "/").concat(tagName, "[").concat(ixInc, "]");
    }
    if (sibling.nodeType === 1 && sibling.tagName === element.tagName) {
      ix++;
    }
  }
};
export var XPathToElement = function XPathToElement(xpath) {
  return document.evaluate(xpath, document, null, XPathResult.FIRST_ORDERED_NODE_TYPE, null).singleNodeValue;
};